import { Component, OnInit } from '@angular/core';

import { UserService } from '../services/user.service';
import { Token } from '../services/user.model';

@Component({
  template: require('./token.component.html')
})
export class UserTokenComponent implements OnInit {
  tokens: Array<Token>;

  constructor(
    private user: UserService,
  ) { }

  getTokens() {
    this.user.getTokens().subscribe(tokens => {
      this.tokens = tokens;
    }, err => {
      console.error(err);
    });
  }

  ngOnInit() {
    this.getTokens();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/account/token.component.ts